module.exports = __webpack_public_path__ + "static/img/1074_big.29afd1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1074_big.png
// module id = 54GC
// module chunks = 1